import { Box, Grid, Typography } from "@mui/material";
import { Line, LineChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis, Legend } from "recharts";
import api from "../services/Axios";
import { useEffect, useState, useMemo } from "react";

const CHART_STYLE = {
    backgroundColor: "#FFFFFF",
    borderRadius: "20px",
    border: "1px solid #EEF0F5",
    boxShadow: "0 2px 8px rgba(17,19,26,0.04)",
};

const formatDate = (raw) => {
    if (!raw || raw.length < 8) return "";
    const y = raw.slice(0, 4), m = raw.slice(4, 6), d = raw.slice(6, 8);
    return new Date(`${y}-${m}-${d}`).toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
};

export default function NewVsReturningTrend({ dateRange, onLoadingChange }) {
    const [rawData, setRawData] = useState([]);
    const [loading, setLoading] = useState(true);

    const getData = async () => {
        const requestId = `new-vs-returning-${Date.now()}-${Math.random()}`;
        setLoading(true);
        onLoadingChange(requestId, true);
        try {
            const res = await api.get("/admin/analytics/ga/new-vs-returning-timeseries", {
                params: dateRange,
            });
            setRawData(res?.data?.rows || []);
        } finally {
            setLoading(false);
            onLoadingChange(requestId, false);
        }
    };

    useEffect(() => {
        getData();
    }, [dateRange, onLoadingChange]);

    const chartData = useMemo(
        () => rawData.filter((r) => r?.date).map((r) => ({ ...r, date: formatDate(r.date) })),
        [rawData]
    );

    return (
        <Grid item xs={12} md={8}>
            <Box borderRadius={2} p={2.5} sx={CHART_STYLE} height="100%">
                <Typography variant="h6" mb={2}>New vs Returning users</Typography>

                {!loading && (
                    <ResponsiveContainer width="100%" height={320}>
                        <LineChart data={chartData}>
                            <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.06)" vertical={false} />
                            <XAxis dataKey="date" stroke="#888" fontSize={12} />
                            <YAxis stroke="#888" fontSize={12} />
                            <Tooltip contentStyle={{ background: "#fff", border: "1px solid #333" }} />
                            <Legend />
                            <Line
                                type="monotone"
                                dataKey="new"
                                name="new"
                                stroke="#2979FF"
                                strokeWidth={2}
                                dot={false}
                                activeDot={{ r: 6 }}
                            />
                            <Line
                                type="monotone"
                                dataKey="returning"
                                name="returning"
                                stroke="#66BB6A"
                                strokeWidth={2}
                                dot={false}
                                activeDot={{ r: 6 }}
                            />
                        </LineChart>
                    </ResponsiveContainer>
                )}
            </Box>
        </Grid>
    );
}